import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeAllModals } from 'reducers/modalReducer';
import { JBErrorModal, JBErrorModalProps, JBErrorViewTechnicalInformation } from '@bjb-gcrm/gcrm-frontend-components';
import { useRuntimeConfig } from 'config/useRuntimeConfig';
import { User } from 'types/User';
import { GlobalState } from 'reducers/stateTypes';

type Props = {
  technicalInfo: Partial<JBErrorViewTechnicalInformation> &
    Pick<JBErrorViewTechnicalInformation, 'title' | 'userErrorMessage'>;
  httpError?: JBErrorModalProps['httpInfoAxiosError'];
  handleClose?: Function;
};

export const JBErrorModalWrapper = ({ technicalInfo, httpError, handleClose }: Props) => {
  const { envInfo } = useRuntimeConfig();
  const user: User = useSelector((state: GlobalState) => state.user.userDetails);
  const dispatch = useDispatch();

  const handleTopCloseButton = () => {
    if (handleClose) {
      handleClose();
    } else {
      dispatch(closeAllModals()); // including itself
    }
  };

  return (
    <JBErrorModal
      open={true}
      handleClose={handleTopCloseButton}
      httpInfoAxiosError={httpError}
      technicalInfo={{
        details: httpError?.message ?? 'Unknown technical details: the developer forgot to specify this information',
        envInfo,
        userInfo: {
          userId: user?.username ?? 'unknown user',
        },
        ...technicalInfo,
      }}
    />
  );
};
